import { MfsStatusCode } from '@metaos/mfs-telemetry';
import { logger } from '../../utility/telemetry';
import { MfsFolderError } from './mfsFolderError';
/**
 * The exception that is thrown unexpected
 *
 * @param message The message that will be returned to the user
 */
export class UnexpectedError extends MfsFolderError {
    constructor(error, message, eventName) {
        eventName = eventName !== null && eventName !== void 0 ? eventName : 'UnexpectedError';
        message = message !== null && message !== void 0 ? message : `Unexpected error`;
        super(message, true, eventName, MfsStatusCode.UnhandledException);
        if (error instanceof Error) {
            logger.logError(eventName, MfsStatusCode.UnhandledException, { errorType: eventName, error, message }, eventName);
        }
    }
}
//# sourceMappingURL=unexpectedError.js.map